export default __webpack_public_path__ + "static/media/palvelut.1a881910.svg";